import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Card,
  DatePicker,
  Form,
  Icon,
  Input,
  message,
  Modal,
  Row,
  Select,
  Tooltip,
} from 'antd';
import moment from 'moment';
import { queryDeleteProj, queryPostProjSave, queryProjInfo } from '@api/task';
import { queryAccountList } from '@api/core/user';
import { BackBtn } from '@comm/BackBtn';
import TagsInput from '@comm/TagsInput';
import { setBackInfo } from '@store/modules/back_info';
import { queryWorkOrg } from '@api/hr/workOrg';

const { RangePicker } = DatePicker;
const { confirm } = Modal;
const { Option } = Select;

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tags: [],
      data: {},
      pageType: 'add',
      administrators: [],
      reviewers: [],
      viewables: [],
      workOrgs: [],
      accountList: [],
      isReleaseloLoading: false,
      typeList: [
        {
          uuid: '0',
          name: '绩效考核',
        },
        {
          uuid: '1',
          name: '政府申报',
        },
        {
          uuid: '2',
          name: '日常任务',
        },
      ],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { accountInfo } = this.props;
    const { setFieldsValue } = this.props.form;
    this.loadWorkOrgs();
    this.loadAccountList();
    if (this.props.params.uuid) {
      this.loadData(this.props.params.uuid);
      this.setState({
        pageType: 'edit',
      });
    } else {
      this.setState({
        administrators: [{ userUuid: accountInfo.userUuid, userName: accountInfo.userName }],
      });
      setFieldsValue({
        administrators: [accountInfo.userUuid],
      });
    }
  }

  // 获取业务部门列表
  loadWorkOrgs = () => {
    queryWorkOrg({ orgUuid: '' }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          workOrgs: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 获取人员列表
  loadAccountList = () => {
    queryAccountList().then(res => {
      if (res.statusCode === 200) {
        const newList = [];
        res.data.map(item => {
          newList.push({
            userName: item.name,
            userUuid: item.uuid,
          });
          return item;
        });
        this.setState({
          accountList: newList,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 获取项目信息
  loadData = uuid => {
    const { setFieldsValue } = this.props.form;
    queryProjInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        const { administrators, reviewers, viewables, tags } = res.data;
        const adminiValue = [];
        const reviewValue = [];
        const viewValue = [];
        // 设置标签
        const newTags = [];
        tags.map((item, index) => {
          newTags.push({
            uid: index,
            name: item,
          });
          return item;
        });
        // 设置人员默认值
        administrators.map(item => {
          adminiValue.push(item.userUuid);
          return item;
        });
        reviewers.map(item => {
          reviewValue.push(item.userUuid);
          return item;
        });
        viewables.map(item => {
          viewValue.push(item.userUuid);
          return item;
        });
        this.setState({
          data: res.data,
          tags: newTags,
          administrators,
          reviewers,
          viewables,
        });
        setFieldsValue({
          administrators: adminiValue,
          reviewers: reviewValue,
          viewables: viewValue,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 保存
  saveProj = status => {
    const { data, tags, administrators, reviewers, viewables } = this.state;
    const params = {
      ...data,
      ...this.props.form.getFieldsValue(),
    };

    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (status === 1) {
          this.setState({
            isReleaseloLoading: true,
          });
        } else {
          this.setState({
            isSaveloLoading: true,
          });
        }
        // 设置标签
        const newTags = [];
        tags.map(item => {
          newTags.push(item.name);
          return item;
        });
        params.tags = newTags;
        params.status = status;
        params.reviewers = reviewers;
        params.viewables = viewables;
        params.administrators = administrators;
        params.beginDate = values.date[0].format('YYYY-MM-DD');
        params.endDate = values.date[1].format('YYYY-MM-DD');
        delete params.date;
        queryPostProjSave(params).then(res => {
          if (res.statusCode === 200) {
            message.success(res.message);
            this.setBackPageInfo(status);
            this.props.router.go(-1);
          } else {
            const reviewersValue = [];
            const viewablesValue = [];
            message.error(res.message);

            // 把原本的审核人员和查看人员还原
            data.reviewers.map(item => {
              if (!reviewers.some(it => it.userUuid === item.userUuid)) {
                reviewers.push(item);
              }
              return item;
            });

            data.viewables.map(item => {
              if (!viewables.some(it => it.userUuid === item.userUuid)) {
                viewables.push(item);
              }
              return item;
            });

            // 设置form select
            reviewers.map(item => {
              reviewersValue.push(item.userUuid);
              return item;
            });

            viewables.map(item => {
              viewablesValue.push(item.userUuid);
              return item;
            });
            this.props.form.setFieldsValue({
              reviewers: reviewersValue,
              viewables: viewablesValue,
            });
          }
          if (status === 1) {
            this.setState({
              isReleaseloLoading: false,
            });
          } else {
            this.setState({
              isSaveloLoading: false,
            });
          }
        });
      }
    });
  };

  // 删除
  showDelConfirm = () => {
    const { uuid } = this.props.params;
    const _this = this;
    confirm({
      title: '确定删除该项目吗?',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        queryDeleteProj({ uuid }).then(res => {
          if (res.statusCode === 200) {
            message.success(res.message);
            _this.props.router.go(-1);
          } else {
            message.error(res.message);
          }
        });
      },
      onCancel() {},
    });
  };

  // 根据情况设置返回页面的信息
  setBackPageInfo = status => {
    const { pageType } = this.state;
    const { backInfo } = this.props;
    if (backInfo.path === `/task/project_launch`) {
      const params = {};
      params.path = backInfo.path;
      params.tabKey = status === 1 ? '1' : '3';
      params.status = status === 1 ? 'PUBLISH' : 'DRAFT';
      params.current = pageType === 'add' ? 1 : backInfo.current;
      params.condition = pageType === 'add' ? '' : backInfo.condition;
      this.props.dispatch(setBackInfo(params));
    }
  };

  // 设置项目类型
  handleSetTags = tags => {
    this.setState({ tags });
  };

  // 设置业务部门name参数
  handleWorkorgChange = (value, option) => {
    this.props.form.setFieldsValue({
      workorgName: option.props.children,
    });
  };

  /** -------------------------------------------设置人员--开始-------------------------------------------------------*/

  changeAdminis = value => {
    const { accountList } = this.state;
    const administrators = [];
    value.map(item => {
      accountList.map(it => {
        if (it.userUuid === item) {
          administrators.push(it);
        }
        return it;
      });
      return item;
    });

    this.setState({
      administrators,
    });
  };

  changeReviewers = value => {
    const { accountList, reviewers } = this.state;
    const newReviewers = [];
    value.map(item => {
      accountList.map(it => {
        if (it.userUuid === item) {
          newReviewers.push(it);
        }
        return it;
      });
      return item;
    });

    newReviewers.map(item => {
      reviewers.map(it => {
        if (it.userUuid === item.userUuid) {
          item.uuid = it.uuid;
        }
        return it;
      });
      return item;
    });

    this.setState({
      reviewers: newReviewers,
    });
  };

  changeViewables = value => {
    const { accountList, viewables } = this.state;
    const newViewables = [];
    value.map(item => {
      accountList.map(it => {
        if (it.userUuid === item) {
          newViewables.push(it);
        }
        return it;
      });
      return item;
    });

    newViewables.map(item => {
      viewables.map(it => {
        if (it.userUuid === item.userUuid) {
          item.uuid = it.uuid;
        }
        return it;
      });
      return item;
    });

    this.setState({
      viewables: newViewables,
    });
  };
  /** -------------------------------------------设置人员--结束-------------------------------------------------------*/

  adminiTitle = () => {
    const content = (
      <div>
        <p style={{ marginBottom: 0 }}>拥有本项目的编辑权限；</p>
        <p style={{ marginBottom: 0 }}>可选多人；</p>
        <p style={{ marginBottom: 0 }}>接收人可在我发布的项目中查看</p>
      </div>
    );
    return (
      <span>
        项目管理员
        <Tooltip title={content}>
          <Icon type="info-circle" style={{ fontSize: '10px' }} />
        </Tooltip>
      </span>
    );
  };

  reviewersTitle = () => {
    const content = (
      <div>
        <p style={{ marginBottom: 0 }}>
          拥有本项目的审批权限，任务结果提交若需审批，则需通过本类目下的人员审核（按填写顺序逐一审批）;
        </p>
        <p style={{ marginBottom: 0 }}>可选多人;</p>
        <p style={{ marginBottom: 0 }}>接收人无法查看到项目，仅过流程时审核</p>
      </div>
    );
    return (
      <span>
        项目审批人
        <Tooltip title={content}>
          <Icon type="info-circle" style={{ fontSize: '10px' }} />
        </Tooltip>
      </span>
    );
  };

  viewablesTitle = () => {
    const content = (
      <div>
        <p style={{ marginBottom: 0 }}>
          拥有本项目执行和协助权限，本项目下的任务执行人和协助人只能从该类目下的人员中选择;
        </p>
        <p style={{ marginBottom: 0 }}>可选多人;</p>
        <p style={{ marginBottom: 0 }}>接收人可在我收到的项目中查看</p>
      </div>
    );
    return (
      <span>
        项目参与人
        <Tooltip title={content}>
          <Icon type="info-circle" style={{ fontSize: '10px' }} />
        </Tooltip>
      </span>
    );
  };

  render() {
    const {
      tags,
      data,
      isReleaseloLoading,
      isSaveloLoading,
      workOrgs,
      typeList,
      accountList,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const ItemLayout = {
      labelCol: { span: 2 },
      wrapperCol: { span: 16 },
    };

    getFieldDecorator('workorgName', {
      initialValue: data.workorgName,
    });
    return (
      <div>
        <Form>
          <Row>
            <BackBtn />
            <Button
              type="primary"
              onClick={() => this.saveProj(1)}
              loading={isReleaseloLoading}
              icon="upload"
            >
              发布
            </Button>
            {!data.status || data.status === 0 ? (
              <Button
                type="primary"
                style={{ marginLeft: '10px' }}
                onClick={() => this.saveProj(0)}
                loading={isSaveloLoading}
                icon="snippets"
              >
                保存为草稿
              </Button>
            ) : null}
            {data.status === 0 ? (
              <Button style={{ marginLeft: '10px' }} onClick={this.showDelConfirm} icon="delete">
                删除
              </Button>
            ) : (
              ''
            )}
          </Row>
          <Card style={{ marginTop: '10px' }}>
            <Row>
              <p style={{ fontSize: '20px', fontWeight: 'bolder' }}>基本信息</p>
            </Row>
            <Form.Item label="项目名称" {...ItemLayout}>
              {getFieldDecorator('name', {
                rules: [{ required: true, message: '请填写项目名称' }],
                initialValue: data.name,
              })(<Input placeholder="请填写项目名称" />)}
            </Form.Item>
            <Form.Item label="项目周期" {...ItemLayout}>
              {data.uuid
                ? getFieldDecorator('date', {
                    rules: [{ required: true, message: '请选择项目周期' }],
                    initialValue: [moment(data.beginDate), moment(data.endDate)],
                  })(<RangePicker style={{ width: '50%' }} />)
                : getFieldDecorator('date', {
                    rules: [{ required: true, message: '请选择项目周期' }],
                  })(<RangePicker style={{ width: '50%' }} />)}
            </Form.Item>
            <Form.Item label="项目标签" {...ItemLayout}>
              {getFieldDecorator('tags')(
                <TagsInput tags={tags} handleSetTags={this.handleSetTags} />,
              )}
            </Form.Item>
            <Form.Item label="业务部门" {...ItemLayout}>
              {getFieldDecorator('workorgUuid', {
                rules: [{ required: true, message: '请选择业务部门' }],
                initialValue: data.workorgUuid,
              })(
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={this.handleWorkorgChange}
                >
                  {workOrgs.map(item => {
                    return <Option key={item.uuid}>{item.name}</Option>;
                  })}
                </Select>,
              )}
            </Form.Item>
            <Form.Item label="项目分类" {...ItemLayout}>
              {getFieldDecorator('type', {
                rules: [{ required: true, message: '请选择项目分类' }],
                initialValue: data.type || data.type === 0 ? `${data.type}` : '',
              })(
                <Select>
                  {typeList.map(item => {
                    return <Option key={item.uuid}>{item.name}</Option>;
                  })}
                </Select>,
              )}
            </Form.Item>
            <Form.Item label="项目描述" labelCol={{ span: 2 }} wrapperCol={{ span: 16 }}>
              {getFieldDecorator('remark', {
                rules: [{ required: true, message: '请填写项目描述' }],
                initialValue: data.remark,
              })(
                <Input.TextArea
                  placeholder="描述"
                  type="textarea"
                  autosize={{ minRows: 3, maxRows: 9 }}
                  maxLength={5000}
                />,
              )}
              <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入5000字</span>
            </Form.Item>
            <Row>
              <p style={{ fontSize: '20px', fontWeight: 'bolder' }}>角色管理</p>
            </Row>
            <Form.Item label={this.adminiTitle()} labelCol={{ span: 2 }} wrapperCol={{ span: 16 }}>
              {getFieldDecorator('administrators', {
                rules: [{ required: true, message: '请选择管理员' }],
              })(
                <Select
                  showSearch
                  mode="multiple"
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={this.changeAdminis}
                >
                  {accountList.map(item => {
                    return <Option key={item.userUuid}>{item.userName}</Option>;
                  })}
                </Select>,
              )}
            </Form.Item>
            <Form.Item
              label={this.reviewersTitle()}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 16 }}
            >
              {getFieldDecorator('reviewers', {
                rules: [{ required: true, message: '请选择审批人' }],
              })(
                <Select
                  showSearch
                  mode="multiple"
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={this.changeReviewers}
                >
                  {accountList.map(item => {
                    return <Option key={item.userUuid}>{item.userName}</Option>;
                  })}
                </Select>,
              )}
            </Form.Item>
            <Form.Item
              label={this.viewablesTitle()}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 16 }}
            >
              {getFieldDecorator('viewables', {
                rules: [{ required: true, message: '请选择可查看成员' }],
              })(
                <Select
                  showSearch
                  mode="multiple"
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={this.changeViewables}
                >
                  {accountList.map(item => {
                    return <Option key={item.userUuid}>{item.userName}</Option>;
                  })}
                </Select>,
              )}
            </Form.Item>
          </Card>
        </Form>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
  accountInfo: state.account_info,
}))(Form.create()(Page));



// WEBPACK FOOTER //
// ./src/components/task/project/PageAdd.js